// extracted by mini-css-extract-plugin
module.exports = {"Container":"NotFound_Container__34QDK","Status":"NotFound_Status__DMY36","Message":"NotFound_Message__2OJoY"};